export default __webpack_public_path__ + "static/media/Pyramide-besoins_pro_n1_physiologiques.c7920784.svg";